/*
 * @Email: zheniscool@163.com
 * @FilePath: /cbibank-web-corporbank/src/utils/form/genOptions.js
 * @Date: 2021-12-21 17:06:17
 * @Author: zhangzhen
 * @LastEditTime: 2021-12-21 17:06:18
 */
import { forOwn } from 'lodash-es'

export function transformObj2SelectOptionsArray (source) {
  const options = []
  forOwn(source, (label, value) => {
    options.push({
      label,
      value
    })
  })
  return options
}
